/**
 * 通知 H5 原生视图组件的状态发生了变化, 这里的action跟operateComponent参数里的action是对应的
 * @type {{SUBPLAY_TEMPLATE_VIEW: number, END_CARD: number, OM: number, WEBVIEW: number, PLAYER_VIEW: number, STORE_KIT_VIEW: number}}
 */
export const COMPONENT_REACT_TYPE = {
    // view 通用事件通知
    VIEW_DESTROYED: 2,
    VIEW_removed: 6,
    VIEW_hided: 7,

    // type 1 类型的 webview 事件通知, web的渲染结果 data：Map(result：2，error："asdf"）（1，成功，2失败，3超时）
    WEBVIEW_LOAD_STATE_CHANGED: 100,

    // type 2 类型的 video player 事件通知
    PLAYERVIEW_PLAYED: 200, //play
    PLAYERVIEW_PAUSEED: 201, //pause
    PLAYERVIEW_RESUMEED: 207, //resume/
    PLAYERVIEW_MUTE_STATE_CHANGED: 204, // data：{"mute":1/2  2非静音 1静音} //mute

    // type 4 类型的 videoTemplateLegacy 相关事件通知
    // action：401，web的渲染结果 data：Map(result：2，error："asdf"）（1，成功，2失败，3超时）
    VIDEO_TEMPLATE_LEGACY_LOAD_STATE_CHANGED: 401,
    VIDEO_TEMPLATE_LEGACY_CLOSE_BUTTON_CLICKED: 402,
    VIDEO_TEMPLATE_LEGACY_NEED_CALL_DEVELOPER: 403,
}

/**
 * COMPONENT_REACT_TYPE 中 WEBVIEW_LOAD_STATE_CHANGED: 100 的子状态
 * @type {{SUCCESS: number, FAILED: number, TIMEOUT: number}}
 */
export const COMPONENT_REACT_100_TYPE = {
    SUCCESS: 1,
    FAILED: 2,
    TIMEOUT: 3,
}

/**
 * COMPONENT_REACT_TYPE 中 PLAYERVIEW_MUTE_STATE_CHANGED: 204 的子状态
 * @type {{SUCCESS: number, FAILED: number, TIMEOUT: number}}
 */
export const COMPONENT_REACT_204_TYPE = {
    MUTED: 1,
    UNMUTED: 2,
}

/**
 * COMPONENT_REACT_TYPE 中 VIDEO_TEMPLATE_LEGACY_LOAD_STATE_CHANGED: 401 的子状态
 * @type {{SUCCESS: number, FAILED: number, TIMEOUT: number}}
 */
export const COMPONENT_REACT_401_TYPE = {
    SUCCESS: 1,
    FAILED: 2,
    TIMEOUT: 3,
}

/**
 * COMPONENT_REACT_TYPE 中 VIDEO_TEMPLATE_LEGACY_NEED_CALL_DEVELOPER: 403 的子状态
 * @type {{showfailed: number, playcompleted: number, dismissed: number, showsuccess: number, endcardshowsuccess: number, clicked: number}}
 */
export const COMPONENT_REACT_403_TYPE = {
    SHOWSUCCESS: 1,
    SHOWFAILED: 2,
    PLAYCOMPLETED: 3,
    ENDCARDSHOWSUCCESS: 4,
    CLICKED: 5,
    DISMISSED: 6,
}